import { decodeJwt } from "./auth";

const CREDENTIAL = "credential";


export function saveUserAuth(credentialResponse){
    const credential = credentialResponse.credential;
    localStorage.setItem(CREDENTIAL, credential);
}

export function logout(){
    localStorage.removeItem(CREDENTIAL);
}


export function getUser() {
    const token = localStorage.getItem(CREDENTIAL);
    return decodeJwt(token);
}
